// selfservice stream: the customer's self-service page, the signing page, and the customer-file card that issues both.
export const en: Record<string, string> = {
  "portal.title": "Your insurance",
  "portal.hello": "Hi {name}",
  "portal.agent": "Your agent",
  "portal.policies": "Your policies",
  "portal.noPolicies": "No policies on file yet.",
  "portal.expires": "Expires",
  "portal.requests": "Open requests",
  "portal.request.id_card": "Request an ID card",
  "portal.request.proof": "Proof of insurance",
  "portal.request.change": "Request a change",
  "portal.request.question": "Ask a question",
  "portal.request.callback": "Call me",
  "portal.request.details": "Tell us what you need",
  "portal.request.send": "Send to the office",
  "portal.request.sent": "Got it. The office will take care of it and reach you.",
  "portal.upload": "Send a photo or document",
  "portal.upload.hint": "ID card, license, registration, a letter from the carrier. Photos are fine.",
  "portal.upload.title": "What is it?",
  "portal.upload.send": "Upload",
  "portal.upload.done": "Received. Thank you.",
  "portal.pay": "Paying",
  "portal.pay.hint": "Pay at the office by cash, card, check or money order, or on the carrier's site. Ask us for a receipt by text.",
  "portal.payments": "Recent receipts",
  "portal.texting": "Text messages",
  "portal.texting.on": "You receive texts from us about your policies. Turn off below.",
  "portal.texting.off": "You are not receiving texts from us about your policies.",
  "portal.texting.consent": "I agree to receive text messages from the agency about my policies (payment reminders, renewals, documents). Message and data rates may apply. Reply STOP to opt out.",
  "portal.texting.enable": "Enable texts",
  "portal.texting.disable": "Stop texts",
  "portal.invalid": "This link is not valid any more. Please call the office.",
  "portal.footer": "This private page was sent to you by your agency. Do not share the link.",
  "sign.title": "Sign a document",
  "sign.review": "Review the document, then sign below.",
  "sign.open": "Open the document",
  "sign.name": "Your full name",
  "sign.draw": "Draw your signature",
  "sign.clear": "Clear",
  "sign.agree": "I agree to sign electronically",
  "sign.submit": "Sign",
  "sign.decline": "I do not want to sign",
  "sign.signed": "Signed. A copy with the signature certificate is in your file.",
  "sign.download": "Download the signed document",
  "sign.declined": "You chose not to sign. The office has been told.",
  "sign.expired": "This signing link has expired. Please ask the office for a new one.",
  "sign.unavailable": "This document is no longer waiting for a signature.",
  "sign.invalid": "This signing link is not valid. Please call the office.",
  "sign.status.pending": "Waiting for signature",
  "sign.status.signed": "Signed",
  "sign.status.declined": "Declined",
  "sign.status.cancelled": "Cancelled",
  "sign.status.expired": "Expired",
  "selfservice.card": "Self-service and signatures",
  "selfservice.link": "Self-service link",
  "selfservice.link.hint": "A private page for the customer: policies, ID card and document requests, uploads, questions, texting consent. No login; the link is the key.",
  "selfservice.link.issue": "Get link",
  "selfservice.link.copy": "Copy",
  "selfservice.link.copied": "Link copied",
  "selfservice.link.text": "Text it",
  "selfservice.link.textBody": "Here is your private {agency} page: {url}",
  "selfservice.link.revoke": "Revoke",
  "selfservice.link.revoked": "Links revoked",
  "selfservice.link.valid": "Valid until",
  "selfservice.sign": "Signatures",
  "selfservice.sign.request": "Request a signature",
  "selfservice.sign.purpose": "Document",
  "selfservice.sign.purpose.um_uim_rejection": "UM/UIM coverage selection (Texas)",
  "selfservice.sign.purpose.pip_rejection": "PIP coverage selection (Texas)",
  "selfservice.sign.purpose.application": "Application (PDF from Documents)",
  "selfservice.sign.purpose.authorization": "Authorization (PDF from Documents)",
  "selfservice.sign.purpose.other": "Other PDF from Documents",
  "selfservice.sign.choice": "Selection",
  "selfservice.sign.choice.0": "Reject the coverage",
  "selfservice.sign.choice.1": "Accept the coverage",
  "selfservice.sign.choice.2": "Accept at lower limits",
  "selfservice.sign.limits": "Limits (optional)",
  "selfservice.sign.document": "PDF",
  "selfservice.sign.policy": "Policy",
  "selfservice.sign.create": "Create signing link",
  "selfservice.sign.created": "Signing link ready",
  "selfservice.sign.openNow": "Sign here now",
  "selfservice.sign.textLink": "Text the link",
  "selfservice.sign.textBody": "Please sign your {title} for {agency} here: {url}",
  "selfservice.sign.cancel": "Cancel",
  "selfservice.sign.cancelled": "Request cancelled",
  "selfservice.sign.signedDoc": "Signed PDF",
  "selfservice.sign.none": "No signature requests yet.",
  "selfservice.sign.legal": "The Texas acknowledgments are prepared by the agency from the customer's selection; the carrier's own form may also be required.",
};

export const es: Record<string, string> = {
  "portal.title": "Su seguro",
  "portal.hello": "Hola {name}",
  "portal.agent": "Su agente",
  "portal.policies": "Sus pólizas",
  "portal.noPolicies": "Aún no hay pólizas registradas.",
  "portal.expires": "Vence",
  "portal.requests": "Solicitudes abiertas",
  "portal.request.id_card": "Pedir tarjeta de seguro",
  "portal.request.proof": "Comprobante de seguro",
  "portal.request.change": "Pedir un cambio",
  "portal.request.question": "Hacer una pregunta",
  "portal.request.callback": "Llámenme",
  "portal.request.details": "Díganos qué necesita",
  "portal.request.send": "Enviar a la oficina",
  "portal.request.sent": "Recibido. La oficina lo atenderá y se comunicará con usted.",
  "portal.upload": "Enviar foto o documento",
  "portal.upload.hint": "Tarjeta de seguro, licencia, registro, una carta de la aseguradora. Las fotos sirven.",
  "portal.upload.title": "¿Qué es?",
  "portal.upload.send": "Subir",
  "portal.upload.done": "Recibido. Gracias.",
  "portal.pay": "Pagos",
  "portal.pay.hint": "Pague en la oficina en efectivo, tarjeta, cheque o giro, o en el sitio de la aseguradora. Pídanos el recibo por mensaje.",
  "portal.payments": "Recibos recientes",
  "portal.texting": "Mensajes de texto",
  "portal.texting.on": "Recibe mensajes nuestros sobre sus pólizas. Puede desactivarlos abajo.",
  "portal.texting.off": "No recibe mensajes nuestros sobre sus pólizas.",
  "portal.texting.consent": "Acepto recibir mensajes de texto de la agencia sobre mis pólizas (recordatorios de pago, renovaciones, documentos). Pueden aplicar tarifas de mensajes y datos. Responda ALTO para cancelar.",
  "portal.texting.enable": "Activar mensajes",
  "portal.texting.disable": "Detener mensajes",
  "portal.invalid": "Este enlace ya no es válido. Por favor llame a la oficina.",
  "portal.footer": "Esta página privada se la envió su agencia. No comparta el enlace.",
  "sign.title": "Firmar un documento",
  "sign.review": "Revise el documento y firme abajo.",
  "sign.open": "Abrir el documento",
  "sign.name": "Su nombre completo",
  "sign.draw": "Dibuje su firma",
  "sign.clear": "Borrar",
  "sign.agree": "Acepto firmar electrónicamente",
  "sign.submit": "Firmar",
  "sign.decline": "No quiero firmar",
  "sign.signed": "Firmado. Una copia con el certificado de firma quedó en su expediente.",
  "sign.download": "Descargar el documento firmado",
  "sign.declined": "Decidió no firmar. La oficina ya lo sabe.",
  "sign.expired": "Este enlace de firma venció. Pida uno nuevo a la oficina.",
  "sign.unavailable": "Este documento ya no está esperando firma.",
  "sign.invalid": "Este enlace de firma no es válido. Por favor llame a la oficina.",
  "sign.status.pending": "Esperando firma",
  "sign.status.signed": "Firmado",
  "sign.status.declined": "Rechazado",
  "sign.status.cancelled": "Cancelado",
  "sign.status.expired": "Vencido",
  "selfservice.card": "Autoservicio y firmas",
  "selfservice.link": "Enlace de autoservicio",
  "selfservice.link.hint": "Una página privada para el cliente: pólizas, tarjeta de seguro y documentos, subir archivos, preguntas, consentimiento de mensajes. Sin contraseña; el enlace es la llave.",
  "selfservice.link.issue": "Obtener enlace",
  "selfservice.link.copy": "Copiar",
  "selfservice.link.copied": "Enlace copiado",
  "selfservice.link.text": "Enviar por mensaje",
  "selfservice.link.textBody": "Aquí está su página privada de {agency}: {url}",
  "selfservice.link.revoke": "Revocar",
  "selfservice.link.revoked": "Enlaces revocados",
  "selfservice.link.valid": "Válido hasta",
  "selfservice.sign": "Firmas",
  "selfservice.sign.request": "Pedir una firma",
  "selfservice.sign.purpose": "Documento",
  "selfservice.sign.purpose.um_uim_rejection": "Selección de cobertura UM/UIM (Texas)",
  "selfservice.sign.purpose.pip_rejection": "Selección de cobertura PIP (Texas)",
  "selfservice.sign.purpose.application": "Solicitud (PDF de Documentos)",
  "selfservice.sign.purpose.authorization": "Autorización (PDF de Documentos)",
  "selfservice.sign.purpose.other": "Otro PDF de Documentos",
  "selfservice.sign.choice": "Selección",
  "selfservice.sign.choice.0": "Rechazar la cobertura",
  "selfservice.sign.choice.1": "Aceptar la cobertura",
  "selfservice.sign.choice.2": "Aceptar con límites menores",
  "selfservice.sign.limits": "Límites (opcional)",
  "selfservice.sign.document": "PDF",
  "selfservice.sign.policy": "Póliza",
  "selfservice.sign.create": "Crear enlace de firma",
  "selfservice.sign.created": "Enlace de firma listo",
  "selfservice.sign.openNow": "Firmar aquí ahora",
  "selfservice.sign.textLink": "Enviar enlace por mensaje",
  "selfservice.sign.textBody": "Por favor firme su {title} para {agency} aquí: {url}",
  "selfservice.sign.cancel": "Cancelar",
  "selfservice.sign.cancelled": "Solicitud cancelada",
  "selfservice.sign.signedDoc": "PDF firmado",
  "selfservice.sign.none": "Todavía no hay solicitudes de firma.",
  "selfservice.sign.legal": "Las constancias de Texas las prepara la agencia a partir de la selección del cliente; puede requerirse además el formulario propio de la aseguradora.",
};
